import { createSlice } from '@reduxjs/toolkit';
import { ReportTabValidationType } from '../../../pages/ifspNew/IfspReportScreens/reportComponents/ifspReportTabValidationCheck';
import { ValidationResult } from '../../../pages/ifspNew/ifspComponents/ifspClientInfoValidationCheck';
import { ServicdeliveryAndConsnetValidationResultType } from '../../../pages/ifspNew/ifspSDPAndConsentScreens/sDPAndConsentsComponents/ifspSDPAndConsentValidationCheck';

interface IfspFormValidationsType
  extends ReportTabValidationType,
    ServicdeliveryAndConsnetValidationResultType,
    ValidationResult {}

export type { IfspFormValidationsType };

export const initialIfspFormValidationsState: IfspFormValidationsType = {
  ifspFirstMeetingDate: false,
  ifspFirstMeetingDateErrorMessageId: '',
  ifspFirstMeetingDateErrorMessage: '',

  ifspFirstMeetingDelay: false,
  ifspFirstMeetingDelayErrorMessageId: '',
  ifspFirstMeetingDelayErrorMessage: '',

  ifspSignedDate: false,
  ifspSignedDateErrorMessageId: '',
  ifspSignedDateErrorMessage: '',

  justification: false,
  justificationErrorMessageId: '',
  justificationErrorMessage: '',

  dateOfEligibilityEvaluation: false,
  dateOfEligibilityEvaluationErrorMessageId: '',
  dateOfEligibilityEvaluationErrorMessage: '',
  dateOfEligibilityEvaluationErrorIndex: [],

  adminAmendmentSignDate: [],
  adminAmendmentSignature: [],
  assessmentCompletedOn: [],
  consentForServiceSignatureDateOne: [],
  consentForServiceSignatureDateTwo: [],
  consentForServiceNotSigned: [],
  consentForServiceagreeDisagreeService: [],
  consentToAccessInsurance: [],
  participatedInIfspDevelopment: [],
  consentToAccessInsuranceNotSigned: [],
  consentToAccessInsuranceSignatureDateOne: [],
  consentToAccessInsuranceSignatureDateTwo: [],
  reestablishedDate: [],
};

const ifspFormValidationsSlice = createSlice({
  name: 'ifspFormValidations',
  initialState: initialIfspFormValidationsState,
  reducers: {
    updateIfspFormValidations: (state, action) => {
      Object.assign(state, action.payload);
    },
    resetIfspFormValidations: (state) => {
      Object.assign(state, initialIfspFormValidationsState);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      'RESET_REDUX_APP_STATES',
      () => initialIfspFormValidationsState,
    );
  },
});

export const { updateIfspFormValidations } = ifspFormValidationsSlice.actions;
export default ifspFormValidationsSlice.reducer;
